var _circle, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraktorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.375,
    cy: 24.375,
    r: 24.375,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1874_10571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8239 9.51298C14.409 11.0776 9.50662 16.9188 9.03724 23.5683C8.59394 30.0093 12.1404 36.0591 17.9555 38.745C20.2242 39.8141 21.9713 40.1792 24.605 40.1792C27.2388 40.1792 28.9859 39.8141 31.2546 38.745C37.0697 36.0591 40.6161 30.0093 40.1728 23.5683C39.7035 16.7884 34.5663 10.8168 28.0472 9.43475C26.274 9.06968 22.4928 9.09575 20.8239 9.51298ZM27.8646 12.1467C36.3135 14.3633 40.1728 24.2985 35.453 31.6782C31.2025 38.3278 21.8931 39.5534 15.9997 34.2598C11.2798 30.0093 10.3411 22.9946 13.7571 17.6489C15.3739 15.1195 18.3466 12.9551 21.2411 12.1728C23.1187 11.6773 25.961 11.6513 27.8646 12.1467Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 14.7283C21.3486 14.9108 20.3316 15.3281 19.7318 15.6149C18.5844 16.2147 16.7852 17.675 16.7852 17.9879C16.7852 18.0922 17.6718 18.7441 18.767 19.4221C20.6184 20.6216 20.7488 20.6477 21.2182 20.2305C21.9744 19.5525 24.0606 19.0309 25.3383 19.2135C25.9381 19.2917 26.8768 19.6568 27.3723 20.0219L28.3111 20.6477L30.2407 19.4482C31.3099 18.7702 32.1704 18.1443 32.1704 18.014C32.1704 17.5707 30.1886 16.0843 28.5979 15.3541C26.6682 14.4414 23.8519 14.1807 22.0005 14.7283Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0091 20.8042C14.3572 22.0037 14.0964 24.5592 14.4093 26.3585C14.9309 29.253 14.9048 29.253 18.3208 27.0104C19.9637 25.9413 21.424 24.9504 21.5543 24.82C21.6847 24.6896 20.6417 23.8551 19.0771 22.8381C17.5907 21.8733 16.1304 20.9085 15.8175 20.6999C15.322 20.3609 15.2177 20.3869 15.0091 20.8042Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8602 22.3427C29.2174 23.4379 27.7571 24.4028 27.6267 24.5331C27.5224 24.6375 28.8784 25.6805 30.6256 26.854C34.3284 29.253 34.2502 29.253 34.7718 26.4367C35.0325 25.0808 35.0325 24.3506 34.7978 22.9685C34.2763 20.074 34.3024 20.074 30.8602 22.3427Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6888 29.9051C17.6457 30.5831 16.7852 31.209 16.7852 31.3133C16.7852 31.7566 18.7931 33.2429 20.3055 33.947C23.0436 35.2248 26.0945 35.2248 28.8848 33.9209C30.0582 33.3473 32.1704 31.7044 32.1704 31.3133C32.1704 31.209 31.2838 30.557 30.2147 29.879L28.2589 28.6795L27.607 29.175C27.2419 29.4618 26.3814 29.8269 25.6512 30.0094C24.6082 30.2702 24.1388 30.2441 22.9653 29.9051C22.183 29.6704 21.4007 29.3054 21.2182 29.0967C21.0357 28.8881 20.827 28.7056 20.7227 28.7056C20.6445 28.7056 19.7057 29.2532 18.6888 29.9051Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1874_10571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.7461,
    y: -6.39893,
    width: 65.3569,
    height: 65.3569,
    transform: "rotate(-2.67353 -10.7461 -6.39893)",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraktorIcon);
export default __webpack_public_path__ + "static/media/traktorIcon.20d51e130cb6592466d6d59f1f2e5b95.svg";
export { ForwardRef as ReactComponent };